import Head from 'next/head';
import Link from 'next/link';

import { Lia } from 'src/components/ui/Lia';
import { Text } from 'src/components/ui/Text';
import { Title } from 'src/components/ui/Title';

const ContractTerms = () => {
  return (
    <div className="mx-auto max-w-2xl p-5 sm:px-0 sm:py-20">
      <Head>
        <meta
          name="robots" 
          content="noindex" 
        />
      </Head>
      <Lia />

      <Title
        size="xl"
        className="my-10"
      >
        Termos de Contrato
      </Title>

      <Title>Definições</Title>
      <Text className="mb-6 mt-4">
        <strong>LIA</strong> - LIA TECNOLOGIA E SERVIÇOS LTDA., pessoa jurídica de direito privado, constituída sob a
        forma de sociedade empresária limitada, inscrita no CNPJ sob o nº 44.432.290/0001-18, com sede na Avenida
        Paulista, nº 777, sala 102, Bela Vista, São Paulo/SP, CEP 01311-914.
        <br />
        <br />
        <strong>Consumidor</strong> - É a pessoa física que deseja utilizar os serviços do PARCEIRO LIA e que efetuará o
        pagamento através da Plataforma LIA.
        <br />
        <br />
        <strong>Partes</strong> - A LIA e o Consumidor: pessoas independentes e distintas.
        <br />
        <br />
        Logo, as “Partes”, resolvem, de comum acordo, firmar os presentes termos de uso para compras na modalidade
        direta, que será regido conforme as seguintes cláusulas e condições seguintes:
      </Text>

      <Title>CLÁUSULA PRIMEIRA – DO OBJETO</Title>
      <Text className="mb-6 mt-4">
        <strong>1.1</strong> Constitui objeto do presente Contrato a prestação de serviços de checkout da compra através
        da Plataforma LIA, que oferecerá a possibilidade de pagamento dos valores referentes às compras que o Consumidor
        efetuar em alguns Parceiros pré-selecionados, nos quais disponibilizamos a Plataforma (sujeito à aprovação),
        para o pagamento através da forma selecionada pelo Consumidor.
        <br />
        <br />
        <strong>1.2</strong> Para cada compra será cobrada uma taxa de comissionamento de 1,97% em cima do valor total
        da compra.
        <br />
        <br />
        <strong>1.3</strong> Deste modo, a relação entre as Partes restringe-se à finalização da compra do cliente pela
        LIA e o pagamento de eventuais parcelas (referentes ao valor final da compra, somado às taxas).
      </Text>
      <Title>CLÁUSULA SEGUNDA – DO PAGAMENTO</Title>
      <Text className="mb-6 mt-4">
        <strong>2.1</strong> O serviço de checkout de pagamentos será prestado para o Consumidor diretamente através da
        Plataforma da LIA no momento da efetivação de sua compra.
        <br />
        <br />
        <strong>2.2</strong> Em casos de cancelamento da compra e pedidos de reembolso, o Consumidor deverá seguir a Lei
        do Consumidor, podendo efetuar o cancelamento sem ônus em até 7 dias da data da compra.
        <br />
        <br />
        <strong>2.3</strong> O cancelamento da compra pelo Consumidor após o prazo indicado acima, não o exime de pagar
        integralmente os valores à LIA, devendo verificar a possibilidade de reembolso diretamente ao PARCEIRO LIA, que
        é a empresa que efetivamente prestará os serviços ao Consumidor.
        <br />
        <br />
        <strong>2.4</strong> A porcentagem referente às taxas cobradas pela LIA, poderão ser revistas a qualquer
        momento, visando acompanhar eventos oriundos da mudança na legislação fiscal, econômico-financeira ou mesmo de
        conteúdo pertinente ao presente Termo, que possam trazer impacto financeiro, causando prejuízo a qualquer das
        partes de forma substancial, mediante as condições da contratação aqui pactuadas.
        <br />
        <br />
        <strong>2.5</strong> Todos os impostos, taxas e contribuições que venham a incidir sobre a prestação dos
        serviços ora contratados serão de exclusiva responsabilidade da parte a que couber, nos termos da legislação
        vigente.
      </Text>
      <Title>CLÁUSULA TERCEIRA – OBRIGAÇÕES DA LIA</Title>
      <Text className="mb-6 mt-4">
        <strong>3.1</strong> A LIA, por força deste instrumento: Não divulgará de forma indevida, nem se utilizará de
        dados e documentos ou informações a que tiver acesso em razão da presente prestação de serviços, relacionados
        aos seus clientes, salvo para garantir a viabilidade deste contrato e a relação comercial, cuja exceção somente
        se aceitará em decorrência de ordem.
      </Text>
      <Title>CLÁUSULA QUARTA – DAS OBRIGAÇÕES DO CONSUMIDOR</Title>
      <Text className="mb-6 mt-4">
        <strong>4.1</strong> Por força deste contrato, o Consumidor:
        <br />
        <br />
        a) Colocará à disposição da LIA, todas as informações necessárias para o pagamento dos serviços que contratará
        com o PARCEIRO LIA, bem como os dados necessários, para que seja possível a análise de viabilização do
        pagamento, mediante as condições previstas neste instrumento, visando o regular desenvolvimento dos serviços
        contratados;
        <br />
        <br />
        b) Comunicará à LIA a ocorrência de fato impeditivo à execução do contrato;
      </Text>
      <Title>CLÁUSULA QUINTA – OBRIGAÇÕES COMUNS</Title>
      <Text className="mb-6 mt-4">
        <strong>5.1</strong> Constituem obrigações comuns à Partes, sem prejuízo das demais inerentes à prestação dos
        serviços:
        <br />
        <br />
        a) Cumprir plenamente legislação vigente e as obrigações pactuadas neste Contrato de modo a favorecer a
        constante melhoria dos serviços e dos resultados obtidos, preservando a outra parte de qualquer demanda ou
        reivindicação de sua exclusiva responsabilidade.
        <br />
        <br />
        b)Manter a outra parte à salvo de reclamações de terceiros e resguardada de quaisquer responsabilidades pelo uso
        indevido, na execução do Contrato, de marcas e patentes, segredos industriais, inventos, logomarcas, logotipos,
        desenhos, métodos, dentre outros direitos de propriedade intelectual previstos na legislação em vigor.
      </Text>
      <Title>CLÁUSULA SEXTA – CLÁUSULA MANDATO</Title>
      <Text className="mb-6 mt-4">
        <strong>
          6.1 Deste modo e, para tal fim, o CONSUMIDOR desde já nomeia a LIA sua bastante procuradora, com poderes
          especiais para, em seu nome e por sua conta:
          <br />
          <br />
          Havendo inadimplência, negociar e obter crédito perante instituições financeiras ou mercado de capitais,
          outorgando-lhe poderes especiais para assinar contratos de financiamento, movimentar os valores financiados,
          acertar prazos, juros e ônus da dívida, repactuar taxas de juros, emitir títulos representativos do débito
          perante as instituições financeiras, ou ainda, substabelecer em todo ou em parte o mandato outorgado, desde
          que não haja alterações no valor do principal acordado entre as Partes.
        </strong>
      </Text>
      <Title>CLÁUSULA SÉTIMA – DAS DECLARAÇÕES E GARANTIAS</Title>
      <Text className="mb-6 mt-4">
        <strong>7.1</strong> A LIA declara expressamente ser sociedade empresária legalmente constituída e habilitada
        para o ramo de serviços envolvidos no presente Contrato, responsabilizando-se, inteiramente, com total isenção
        da Parceira, pelas atividades decorrentes das obrigações assumidas.
        <br />
        <br />
        <strong>7.2</strong> As PARTES reconhecem que o presente Contrato está sujeito à execução específica, sendo
        elevado, o contrato, a título executivo extrajudicial (CPC, art. 784, III), permitindo sua execução sem a
        necessidade de processo de conhecimento prévio.
      </Text>
      <Title>CLÁUSULA OITAVA - DO PRAZO E DA RESCISÃO</Title>
      <Text className="mb-6 mt-4">
        <strong>8</strong> O presente Contrato terá início na data de sua assinatura e vigorará até a quitação do
        débito, pelo Consumidor que possuir qualquer tipo de pendência.
        <br />
        <br />
        <strong>8.1.</strong> Em caso de rescisão, por qualquer motivo, as partes deverão acertar os valores que
        estiverem em aberto até o prazo do efetivo rompimento do contrato, nada mais tendo a reclamar uma da outra, em
        qualquer esfera, salvo verificada situação posterior que enseje revisão.
        <br />
        <br />
        <strong>8.2.</strong> Este Contrato será rescindido independentemente de notificação judicial ou extrajudicial
        nos seguintes casos:
        <br />
        <br />
        a) Descumprimento das cláusulas deste contrato, incluindo o não pagamento de valores em aberto na data
        estipulada pela LIA, não sanada pela Parte inadimplente, no prazo de 5 dias (incluso o não pagamento das
        parcelas vincendas), e;
        <br />
        <br />
        b) Recuperação judicial ou extrajudicial, falência ou constatação de estado de insolvência de qualquer das
        partes.
      </Text>
      <Title>CLÁUSULA NONA – DAS DISPOSIÇÕES GERAIS</Title>
      <Text className="mb-6 mt-4">
        <strong>9</strong> Este Contrato e as “Políticas LIA”, assinaladas pelo Consumidor, constitui o acordo integral
        a respeito da relação entre as Partes, substituindo e revogando as tratativas, entendimentos e/ou ajustes
        firmados anteriormente pelas Partes, de forma verbal ou escrita, até a data de sua celebração.
        <br />
        <br />
        <strong>9.1</strong> Nenhuma alteração deste Contrato será considerada válida, exceto se formalizada por meio de
        aditivo contratual escrito e assinado pelas Partes.
        <br />
        <br />
        <strong>9.2</strong> Toda e qualquer comunicação que envolva responsabilidade contratual, tanto por parte da LIA
        como da Parceira, somente terá validade se efetuada por escrito e encaminhada à equipe de Suporte da LIA:
        <br />
        <br />
        a)Para a LIA: A/C do e-mail atendimento@lia.com.br
        <br />
        <br />
        b)Para o Consumidor: No e-mail informado em seu cadastro.
        <br />
        <br />
        <strong>9.3</strong> O presente Contrato obriga as partes e sucessores a cumprirem e a fazerem cumprir a
        qualquer tempo as cláusulas ora pactuadas.
        <br />
        <br />
        <strong>9.4</strong> O CONSUMIDOR declara a ciência e concorda que, havendo recusa ou atraso de pagamento das
        parcelas, por prazo superior a 30 (trinta) dias, poderá a LIA solicitar a inscrição do seu nome nos cadastros
        mantidos pelos órgãos de proteção ao crédito, nos termos do art. 43, parágrafo 2º, da lei nº 8.078/90 (Código de
        Defesa do Consumidor).
        <br />
        <br />
        <strong>9.5</strong> Não valerá como precedente, novação ou renúncia aos direitos que a lei e o presente
        Contrato asseguram às partes o não exercício desses direitos ou a tolerância por quaisquer delas de eventuais
        infrações da outra ou das cláusulas aqui estipuladas.
      </Text>
      <Title>CLÁUSULA DÉCIMA - DO FORO DE ELEIÇÃO</Title>
      <Text className="mb-6 mt-4">
        As partes, de comum acordo, elegem o foro de alguma das comarcas da capital do Estado de São Paulo, para dirimir
        qualquer lide oriunda do presente Contrato, com renúncia expressa de qualquer outro por mais privilegiado que
        seja.
        <br />
        <br />
        E, por estarem assim justas e contratadas, de um lado o CONSUMIDOR, que estará utilizando as facilidades
        propostas pela Plataforma LIA e, do outro, a LIA, sendo que assinam as partes o presente Contrato, de forma
        digital, nos Termos da Lei, surtindo os regulares efeitos.
      </Text>

      <footer className="mt-10 flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
        <Link
          href="/politica-de-privacidade"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de privacidade
        </Link>
        <Link
          href="/politica-de-cookies"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de cookies
        </Link>
        <Link
          href="/termos-de-uso"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de uso
        </Link>

        <Link
          href="/termos-de-contrato"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de Contrato
        </Link>
      </footer>
    </div>
  );
};

export default ContractTerms;
